'use client';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect } from 'react';
import { ROUTES } from '../../../constants';
import { FilledButton } from '..';
import { getLogger } from '../../logger/logger';
import { usePath } from '../../hooks';
import { ErrorBox, ErrorImage } from './styles';
import { BodyLarge, HeadlineLarge } from '../../styles';
import { useTranslations } from 'next-intl';

export interface ErrorProps {
    error: Error;
    reset: () => void;
}

export const Error = ({ error, reset }: ErrorProps) => {
    const path: ROUTES[number] = usePath();
    const logger = getLogger(path);
    const t_error = useTranslations('error');

    useEffect(() => {
        console.error(error);
        logger.error(error.message);
    }, [error, logger]);

    return (
        <ErrorBox>
            <ErrorImage width='100%' height='100%' />
            <HeadlineLarge mb={1}>{t_error('title')}</HeadlineLarge>
            <BodyLarge mb={5}>{t_error('pls_try_again')}</BodyLarge>
            <FilledButton icon={<RefreshIcon />} label={t_error('reload_page')} onClick={reset}>
                {t_error('reload_page')}
            </FilledButton>
        </ErrorBox>
    );
};
